export const ALL_USER_GROUPS_BUT_GUESTS = [
  "standard_user",
  "specialist_user",
  "producer_user",
  "editor_user"
];

export default {
  ALL_USER_GROUPS_BUT_GUESTS
};
